var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 308,
    viewBox: "0 0 349 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.9543 0 0 8.95431 0 20V259V287.088C0 303.553 18.7827 312.965 31.9718 303.109L85.6753 262.979C89.1321 260.396 93.3317 259 97.6471 259H329C340.046 259 349 250.046 349 239V20C349 8.9543 340.046 0 329 0H20Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentBox);
export default __webpack_public_path__ + "static/media/comment-box.7c24da87ca28702ca63052ee433fe216.svg";
export { ForwardRef as ReactComponent };